import { render, staticRenderFns } from "./IndividualPointsList.vue?vue&type=template&id=8d5ffadc&scoped=true"
import script from "./IndividualPointsList.vue?vue&type=script&lang=js"
export * from "./IndividualPointsList.vue?vue&type=script&lang=js"
import style0 from "./IndividualPointsList.vue?vue&type=style&index=0&id=8d5ffadc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d5ffadc",
  null
  
)

export default component.exports